<a
  class="fc-day-grid-event fc-h-event fc-event fc-start fc-end fc-draggable fc-resizable"
  *ngIf="eventOpts?.view"
  [style.height]="height"
  [style.backgroundColor]="eventOpts.view.color"
  [style.borderColor]="eventOpts.view.borderColor || eventOpts.view.color"
  [style.borderWidth]="eventOpts.attributes.dirty ? '5px' : '0'"
  [style.borderStyle]="eventOpts.view.borderStyle"
  [popover]="dayPop"
  container="body"
  [popoverTitle]="eventOpts.view.transId | translate"
  triggers="mouseenter:mouseleave">
  <ng-container *ngIf="!(isReadOnly || eventOpts.view.readOnly)">
        <span class="fc-icon fc-icon-left-single-arrow"
              style="left: 0;"
              [style.backgroundColor]="eventOpts.view.borderColor || 'white'"
              *ngIf="this.isHover && isBegining"
              (click)="decreaseStart()">
        </span>
    <span class="fc-icon fc-icon-right-single-arrow"
          style="left: 0; margin-left: 15px;"
          [style.backgroundColor]="eventOpts.view.borderColor || 'white'"
          *ngIf="!this.isSingleDay && this.isHover && isBegining"
          (click)="increaseStart()">
        </span>
    <div class="icon-btn" data-action="edit" style="left: calc(50% - 30px);" *ngIf="isHover"
         [style.backgroundColor]="eventOpts.view.borderColor || 'white'">
      <i class="fa fa-light fa-pencil-alt pointer"></i>
    </div>
    <div class="icon-btn" data-action="delete" style="left: calc(50% - 10px);" *ngIf="isHover"
         [style.backgroundColor]="eventOpts.view.borderColor || 'white'">
      <i class="fa fa-light fa-trash-alt pointer"></i>
    </div>
    <div class="icon-btn" data-action="view" style="left: calc(50% + 10px);" *ngIf="isHover"
         [style.backgroundColor]="eventOpts.view.borderColor || 'white'">
      <i class="far fa-eye pointer"></i>
    </div>
  </ng-container>
  <div class="fc-content" *ngIf="showContent">
    <span class="fc-title">{{eventOpts.view.transId | translate}}</span>
  </div>
  <ng-container *ngIf="!(isReadOnly || eventOpts.view.readOnly)">
        <span class="fc-icon fc-icon-left-single-arrow"
              style="right: 0; margin-right: 15px;"
              [style.backgroundColor]="eventOpts.view.borderColor || 'white'"
              *ngIf="!this.isSingleDay && this.isHover && isEnding"
              (click)="decreaseEnd()">
        </span>
    <span class="fc-icon fc-icon-right-single-arrow"
          style="right: 0;"
          [style.backgroundColor]="eventOpts.view.borderColor || 'white'"
          *ngIf="this.isHover && isEnding"
          (click)="increaseEnd()">
        </span>
  </ng-container>
</a>
<ng-template #dayPop>
  <ul class="list-unstyled" style="min-width: 130px" *ngIf="!isTeamPlanning">
    <li class="nowrap" *ngIf="eventOpts.attributes.hoursWorked">
      {{ 'PAYROLL_PREPARE.hours_worked' | translate }}: {{ eventOpts.attributes.hoursWorked }}
    </li>
    <li class="nowrap" *ngIf="eventOpts.attributes.hoursPaid">
      {{ 'PAYROLL_PREPARE.hours_paid' | translate }}: {{ eventOpts.attributes.hoursPaid }}
    </li>
    <li class="nowrap">
      {{ 'PAYROLL_PREPARE.start_date' | translate }}: {{ eventOpts.attributes.begin | gpDate }}
    </li>
    <li class="nowrap">
      {{ 'PAYROLL_PREPARE.end_date' | translate }}: {{ eventOpts.attributes.end | gpDate }}
    </li>
    <li class="nowrap">
      {{ 'PAYROLL_PREPARE.duration_of_hours' | translate:{hours: getDuration()} }}
    </li>
    <li class="nowrap" *ngIf="eventOpts.attributes.values">
      &hellip;
    </li>
  </ul>
</ng-template>
